<template>
  <div class="PersonalData" style="margin-top: 20px">
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <h3>考籍信息</h3>
        </div>
      </template>
      <div class="card-text">
        <div>
          <div class="text">
            <span class="text-title">学号：</span>
            <span>{{ SchoolData.student_id }}</span>
          </div>
          <div class="text">
            <span class="text-title">班级：</span>
            <span>{{ SchoolData.className }}</span>
          </div>
          <div class="text">
            <span class="text-title">教学点：</span>
            <span>{{ SchoolData.centerName }}</span>
          </div>
          <div class="text">
            <span class="text-title">详细核对信息：</span>
            <span>{{ SchoolData.class }}</span>
          </div>
        </div>
        <div>
          <div class="text">
            <span class="text-title">专业：</span>
            <span>{{ SchoolData.specialityName }}</span>
          </div>
          <div class="text">
            <span class="text-title">入学日期：</span>
            <span v-if="SchoolData.formatted_entrance_time">{{ SchoolData.formatted_entrance_time }}</span>
          </div>
          <div class="text">
            <span class="text-title">学籍状态：</span>
            <span>{{ SchoolData.state }}</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { getstudentrecord } from "@/api/mine";
import { ref } from "vue";

const SchoolData = ref({});

getstudentrecord({}).then((res) => {
  res.dataObj.add_party_time = dayjs(res.dataObj.add_party_time).format("YYYY.MM.DD");
  SchoolData.value = res.dataObj;
});
</script>

<style lang="scss" scoped>
.card-text {
  padding: 40px 150px 0 150px;
  display: flex;
  justify-content: space-between;
  .text {
    margin-bottom: 40px;
    font-size: 16px;
    .text-title {
      font-size: 18px;
      color: #a6a6a6;
      margin-right: 10px;
    }
  }
}
</style>